/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/

import { combineReducers } from 'redux';

// Reducers
import puff from './puff';
import feed from './feed';
import view from './view';
import app from './app';
import auth from './auth';

// Combine Reducers
var reducers = combineReducers({
    feeds: feed,
    view: view,
    puff: puff,
    app: app,
    auth: auth
});

export default reducers;
